import { EventRepository } from '~repositories/EventRepository';
import { serviceCommands } from '@estee/elc-service-bus';
import serviceNames from '~setup/AnalyticsService';
import { diContainer } from '~setup/diContainer';
import { Event } from '~entities/Event';

export class PaymentMethodCompletedUseCase {
    private eventRepository: EventRepository;

    constructor() {
        this.eventRepository = diContainer.get(serviceNames.eventRepository);
    }

    public execute = () => {
        const paymentMethodCompletedPayload = {
            event_name: 'payment',
            event_category: 'ecommerce',
            event_action: 'checkout',
            event_label: 'Payment'
        };

        const newEvent = new Event({
            id: this.eventRepository.generateId(),
            name: serviceCommands.ORDER_CREATE,
            type: 'link',
            payload: paymentMethodCompletedPayload
        });

        this.eventRepository.addEventToQueue(newEvent);
    };
}
